var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.171387 13.6791C0.171387 6.12434 6.29989 0 13.8598 0H95.0124C102.572 0 108.701 6.12434 108.701 13.6791V94.7766C108.701 102.331 102.572 108.456 95.0124 108.456H13.8598C6.29989 108.456 0.171387 102.331 0.171387 94.7766V13.6791Z",
    fill: "white",
    fillOpacity: 0.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55518 19.9125C6.55518 12.4386 12.6855 6.37975 20.2476 6.37975H89.688C97.2501 6.37975 103.38 12.4386 103.38 19.9125V88.5432C103.38 96.0171 97.2501 102.076 89.688 102.076H20.2476C12.6855 102.076 6.55518 96.0171 6.55518 88.5432V19.9125Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.688 7.34638H20.2476C13.2257 7.34638 7.53321 12.9724 7.53321 19.9125V88.5432C7.53321 95.4833 13.2257 101.109 20.2476 101.109H89.688C96.71 101.109 102.402 95.4833 102.402 88.5432V19.9125C102.402 12.9724 96.71 7.34638 89.688 7.34638ZM20.2476 6.37975C12.6855 6.37975 6.55518 12.4386 6.55518 19.9125V88.5432C6.55518 96.0171 12.6855 102.076 20.2476 102.076H89.688C97.2501 102.076 103.38 96.0171 103.38 88.5432V19.9125C103.38 12.4386 97.2501 6.37975 89.688 6.37975H20.2476Z",
    fill: "url(#paint0_linear_20_108)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7319 41.2701C42.7319 38.9162 45.2642 37.4873 47.2038 38.7468L67.9778 52.2362C69.7838 53.4089 69.7838 56.1101 67.9778 57.2828L47.2038 70.7722C45.2642 72.0317 42.7319 70.6028 42.7319 68.2489V41.2701Z",
    fill: "url(#paint1_linear_20_108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_108",
    x1: 103.989,
    y1: 7.49994,
    x2: -9.78017,
    y2: 69.5783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_108",
    x1: 72.0468,
    y1: 36.2859,
    x2: 34.1591,
    y2: 52.0192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.27dd003bb76893298bedf0cfb0a86511.svg";
export { ForwardRef as ReactComponent };